document.head.insertAdjacentHTML(
    "beforeend",
    '<style id="slider--fade-effect">' +
        ".slider.slider--effect-fade{scroll-behavior: auto !important; overflow: hidden !important;}" +
        ".slider__slide :is(img, video, iframe) ~ :is(img, video, iframe) {" +
        "transition-property:opacity;" +
        "transition-timing-function:cubic-bezier(.4,0,.2,1);" +
        "transition-duration: 1s;" +
        "}" +
        ".slider__slide .fade--transition:is(img, video, iframe) {" +
        "opacity:0;" +
        "}" +
        "</style>"
);

const _getElementTransitionDurationMs = (element) => {
    const { transitionDuration } = window.getComputedStyle(element);
    const _float = parseFloat(transitionDuration);

    return isNaN(_float)
        ? 0
        : _float * (transitionDuration.indexOf("ms") > 0 ? 1 : 1000);
};

class EffectFade {
    constructor(component) {
        this.component = component;
        this.startX = null;
        this.startY = null;
        this._handleTouchStart = this._onTouchStart.bind(this);
        this._handleTouchEnd = this._onTouchEnd.bind(this);
        this._handleMouseDown = this._onMouseDown.bind(this);
        this._handleMouseUp = this._onMouseUp.bind(this);
    }

    connectedCallback() {
        this.component.addEventListener("touchstart", this._handleTouchStart);
        this.component.addEventListener("touchend", this._handleTouchEnd);
        this.component.addEventListener("mousedown", this._handleMouseDown);
        this.component.addEventListener("mouseup", this._handleMouseUp);
    }

    _onTouchStart(event) {
        const firstTouch = event.touches[0];
        this.startX = firstTouch.clientX;
        this.startY = firstTouch.clientY;
    }

    _onMouseDown = (event) => {
        this.startX = event.clientX;
        this.startY = event.clientY;
    };

    _onTouchEnd(event) {
        const { startX, startY } = this;

        if (!startX || !startY) return;

        const endX = event.changedTouches[0].clientX;
        const endY = event.changedTouches[0].clientY;

        const xDiff = endX - startX;
        const yDiff = endY - startY;

        // Horizontal swipe detection
        if (Math.abs(xDiff) > Math.abs(yDiff)) {
            xDiff > 0 ? this.swipeRight() : this.swipeLeft();
        }

        // Reset coordinates
        this.startX = null;
        this.startY = null;
    }

    _onMouseUp = (event) => {
        const { startX, startY } = this;

        if (!startX || !startY) return;

        const endX = event.clientX;
        const endY = event.clientY;

        const xDiff = endX - startX;
        const yDiff = endY - startY;

        if (Math.abs(xDiff) > Math.abs(yDiff)) {
            this.component.isSwipeAction = true;
            setTimeout(() => (this.component.isSwipeAction = false), 200);
            // Horizontal swipe
            xDiff > 0 ? this.swipeRight() : this.swipeLeft();
        }

        // Reset coordinates
        this.startX = null;
        this.startY = null;
    };

    swipeLeft() {
        const { component } = this;
        component.currentPage < component.totalPages && component.goTo("next");
    }

    swipeRight() {
        const { component } = this;
        component.currentPage > 1 && component.goTo("prev");
    }

    scrollTo(options) {
        const { component } = this;
        const { slider } = component;
        const slides = component.getSlides();
        const slidesPerView = component.dataset?.slidesPerView || 1;
        const _scroll = () => {
            options.behavior = "instant"; // Make sure it's instant
            slider.scrollTo(options);
        };

        let sourceSlide = component.getActiveSlide();
        let targetSlide =
            document.dir == "rtl"
                ? slides.find(
                      (s) =>
                          options.left + slider.clientWidth >=
                          s.offsetLeft + s.clientWidth
                  )
                : slides.find((s) => options.left <= s.offsetLeft);

        for (let i = 0; i < slidesPerView; i++) {
            let sourceWrapper =
                sourceSlide?.querySelector?.("div.image--wrapper");
            let targetWrapper =
                targetSlide?.querySelector?.("div.image--wrapper");

            if (!sourceWrapper || !targetWrapper) break;

            targetWrapper.children[0].style.opacity = "0"; // hide the image to prevent flickering
            targetWrapper.children[1]?.remove?.(); // remove the previous image just for sure
            targetWrapper.append(sourceWrapper.children[0].cloneNode(true));

            sourceSlide = sourceSlide.nextElementSibling;
            targetSlide = targetSlide.nextElementSibling;
        }

        _scroll();
        window.requestAnimationFrame(() => {
            slides.forEach((slide) => {
                let wrapper = slide.querySelector("div.image--wrapper");
                let imageOriginal = wrapper?.children[0];
                let imageToFade = wrapper?.children[1];
                if (imageOriginal)
                    setTimeout(() => (imageOriginal.style.opacity = ""), 100);
                if (imageToFade) {
                    imageToFade.classList.add("fade--transition");
                    setTimeout(() => {
                        imageToFade.remove();
                    }, _getElementTransitionDurationMs(imageToFade) + 100);
                }
            });
        });
    }

    disconnectedCallback() {
        this.component.removeEventListener(
            "touchstart",
            this._handleTouchStart
        );
        this.component.removeEventListener("touchend", this._handleTouchEnd);
        this.component.removeEventListener("mousedown", this._handleMouseDown);
        this.component.removeEventListener("mouseup", this._handleMouseUp);
    }
}

export { EffectFade as Effect };
